import { render, staticRenderFns } from "./BundleComponentDetails.vue?vue&type=template&id=cc4e56ec&"
import script from "./BundleComponentDetails.vue?vue&type=script&lang=js&"
export * from "./BundleComponentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports